var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chunk-loading",style:({minHeight: _vm.minHeight + 'px'}),attrs:{"role":"status","aria-label":_vm.$t('chunkLoading')}},[_c('div',{staticClass:"chunk-loading__spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }